Edit ausentamos 24 de mayo 





<template>
  <div id="absenteeism">
    <div class="p-2">
      <div class="d-flex align-items-center justify-content-start">
        <img class="centerImg1 mr-3" src="@/assets/images/icons/event_seat_2.svg" width="25px">
        <h3 class="title-h3">Ausentismos</h3>
      </div>

      <!-- Bottones de opciones -->
      <div class="mt-5 p-0 col-12 d-flex align-items-center justify-content-between">
        <router-link :to="'../../employee'"
                     class="button-v2 no-border-primary d-flex align-items-center float-right">
          <div class="textButtonColapse m-3 d-flex align-items-center justify-content-between">
            <p class="m-0 pr-2">Volver</p>
            <span>
              <img class="centerImg1 arrow" src="@/assets/images/icons/ht_icon_history.svg" width="15px" />
            </span>
          </div>
        </router-link>
      </div>
      <!-- end -->
      <!-- Formulario de edicion -->
      <div class="history-absenteeism mt-5">
        <div class="history-grib row">
          <p class=" col-12 title-form-history">Fecha y hora de registro </p>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Fecha y hora de registro</label>
              <input type="text"  :value="absenteeism.created" class="form-control form-control mt-4" placeholder="2/12/2026" id="__BVID__88"><!----><!----><!----></div>
            </fieldset>
          </div>
          <p class=" col-12 title-form-history mb-4 mt-5">Caracterización</p>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
                <label>Tipo de ausentismo</label>
              <v-select :placeholder="absenteeism.type_absenteeism_name" class="mt-4 col-12 p-0" label="name" :options="typesAbsenteeism" v-model="typeAbsence" @search="filterTypesAbs" @input="actGetRiskClassification(),checkTypeOfAbs()">
                <template slot="no-options">
                  Ningun resultado encontrado...
                </template>
              </v-select>
              <div class="error">Campo obligatorio*</div>
            </div>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2" >
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Clasificación del riesgo o peligro</label></div>
              <v-select placeholder="Selecciona clasificación del riesgo o peligro" class="mt-4 col-12 p-0" label="name" :options="riskClassification" v-model="riskClassificationSelected" @search="filterRiskClassification" @input="actGetGroupsDiagnostics(), disableFirstStep()">
                <template slot="no-options">
                  Ningun resultado encontrado...
                </template>
              </v-select>
              <div class="error">Campo obligatorio*</div>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2" >
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Grupo de diagnóstico</label></div>
              <v-select placeholder="Selecciona grupo de diagnóstico" class="mt-4 col-12 p-0" label="code_name" :options="groupsDiagnostics" v-model="groupDiagnostic" @search="filterGroupsDiagnostics" @input="filterDiagnosticsByGroup">
                <template slot="no-options">
                  Ningun resultado encontrado...
                </template>
              </v-select>
              <div class="error">Campo obligatorio*</div>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2" >
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Diagnóstico</label></div>
              <v-select placeholder="Selecciona el diagnóstico" class="mt-4 col-12 p-0" label="code_name" :options="diagnostics" v-model="diagnosticSelected" @search="filterGroupsDiagnostics" @input="disableFirstStep()">
                <template slot="no-options">
                  Ningun resultado encontrado...
                </template>
              </v-select>
              <div class="error">Campo obligatorio*</div>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Emisor de la ausencia</label></div>
              <b-form-select class="mt-4" v-model="selectedIssuer" :options="optionsIssuer" @input="disableFirstStep()"></b-form-select>
              <div class="error">Campo obligatorio*</div>
            </fieldset>
          </div>
          <p class=" col-12 title-form-history mb-4 mt-5">Detalle</p>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
               <label>Fecha de inicio del ausentismo</label></div>
               <b-form-datepicker
                :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                v-model="reportFrom"
                class="mb-3 mt-4"
                locale="es-CO"></b-form-datepicker>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Fecha final del ausentismo</label></div>
              <b-form-datepicker
                            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                            :min="reportFrom"
                            v-model="reportTo"
                            class="mb-3 mt-4"
                            locale="es-CO"></b-form-datepicker>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Total de días perdidos</label></div>
              <input @keyup="getHours"
                               class="mt-4"
                               type="number"
                               v-model="daysAbs"
                               name=""
                               min="1"
                               :max="get_difference_register_absenteeism"
                               placeholder="Días perdidos" autofocus>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Horas de ausencia</label></div>
              <input class="mt-4"
                               type="number"
                               v-model="hoursAbs"
                               name=""
                               min="8"
                               :max="get_difference_register_absenteeism_hours"
                               placeholder="Horas de ausencia" autofocus>
              <div class="error">Campo obligatorio*</div>
            </fieldset>
          </div>
          <p class=" col-12 title-form-history mb-4 mt-5">Descripción</p>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Descripción de la ausencia </label></div>
              <textarea v-model="descriptionAbs" type="text" name="" id="" placeholder="Descripción de la ausencia" rows="10" heigth="200px" ></textarea>
              <div class="error">Campo obligatorio*</div>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!---->
              <b-form>
                <label for="feedback-user">Médico que emite la incapacidad</label>
                <b-form-input class="mt-4 mb-3" :state="validateText(medicalDisability)" placeholder="Escribe el nombre del médico" v-model="medicalDisability"  id="feedback-user"></b-form-input>
                <b-form-invalid-feedback :state="validateText(medicalDisability)" >
                  Solo se puede agregar texto.
                </b-form-invalid-feedback>
              </b-form>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Origen de la incapacidad</label></div>
              <b-form-select class="mt-4 mb-3" v-model="inabilityOrigin" :options="optionsOrigen"></b-form-select>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6">
              <b-form>
                <label for="feedback-user">Ips de la incapacidad</label>
                <b-form-input class="mt-4 mb-3" :state="validateText(incapacityIps)" v-model="incapacityIps"  id="feedback-user"></b-form-input>
                <b-form-invalid-feedback :state="validateText(incapacityIps)">
                  Solo se puede agregar texto.
                </b-form-invalid-feedback>
              </b-form>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2">
            <fieldset class="form-group " cols="6"><!----><div>
              <label>Estado del certificado del ausentismo</label></div>
              <b-form-select class="mt-4" v-model="selectedCertificate" :options="optionsCertificate" ></b-form-select>
              <div class="error">Campo obligatorio*</div>
            </fieldset>
          </div>
          <div class="col-12 col-md-6 my-2">
            <div v-if="selectedCertificate != null && selectedCertificate.id == 'pending'" class="box-input">
            </div>
            <div v-if="selectedCertificate != null && selectedCertificate.id == 'received'" class="box-input">
              <label class="m-0 mb-4">Por favor adjunta el certificado del ausentismo</label>
              <input type="file" class="form-control mt-4" v-on:change="onFileChange" >
            </div>
          </div>
          <div class="mt-2 mb-5 col-12">
            <button
                class=" btn btn-success"
                :disabled="processing"
                @click="SaveEditAbs">Guardar Cambios</button>
          </div>
          <div class="row box-error">
            <div class="col-12 pt-5" align="center">


            </div>
          </div>
        </div>
      </div>
      <!-- end Formulario de edicion -->

      <!-- 3 MODAL PROCESO EXITOSO  -->
      <b-modal id="modal-success" hide-footer centered no-close-on-backdrop>
        <div class="col-12 d-flex flex-column align-items-center">
          <img class="centerImg1" src="@/assets/images/icons/check_circle_green.svg" width="20%">
          <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
          <p class="pt-5">{{ message.message }}</p>
          <button class="mt-5 mb-5 col-6 btn btn-success" @click="$bvModal.hide('modal-success'),refreshData()">Entendido</button>
        </div>
      </b-modal>

      <!-- 4 MODAL PROCESO FALLIDO -->
      <b-modal v-if="error.message" id="modal-fail" hide-footer centered no-close-on-backdrop>
        <div class="col-12 d-flex flex-column align-items-center">
          <img class="centerImg1" src="@/assets/images/icons/close.svg" width="20%">
          <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
          <p class="pt-5">{{error.message}}</p>
          <button class="mt-5 mb-5 col-6 btn btn-danger" @click="$bvModal.hide('modal-fail'),refreshData()">Entendido</button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapState,mapActions, mapGetters } from "vuex";
import Pagination from "laravel-vue-pagination";
import PieChart from "@/components/charts/PieChart.js";
import Multiselect from 'vue-multiselect'
export default {
  components: {
    PieChart,
    Pagination,
    Multiselect
  },
  props: {
    dataUser:{},
    userAbs:{},
    nameStadistcs:{},
    totalAbsenteeism:{},
    time:{},
    filterButton:Boolean,
    HistoryButtonAbs:Boolean,
    stadistics: String,
    pagination:Boolean

  },
  data() {
    return {

      //   Variables del filtro
      filterFrom:'',
      filterTo:'',
      optionsDiagFilter:[{value:null,text:'Diagnóstico'}],
      optionsAbsFilter:[],
      selectedDiagFilter:{value:null,text:'Diagnóstico'},
      selectedAbsFilter:[],
      popoverShow:false,

      //   Variables del Historial
      fieldsHistoryAbs:[],
      itemsHistoryAbs:[],
      chartLabels: {},
      chartData: {},
      buttonCancellConfirm:'',
      buttonSaveConfirm:'',
      textConfirm:'',
      selectedCertificate:null,
      selectedIssuer:null,
      groupDiagnostic:'',
      typeAbsence:'',
      diagnosticSelected:'',
      riskClassificationSelected:'',
      datatableEmployeeModal: {
        columns:[],
        rows:[]
      },
      datatableAbs: {
        total: 18,
        perPage: 20,
        columns: [],
        rows: [],
      },
      tableConfirm1: {
        columns:[
          {
            label: "Tipo",
            field: "type",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Diagnostico CIE XI",
            field: "cie",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Emisor",
            field: "issuer",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
        ],
        rows:[]
      },
      tableConfirm2: {
        columns:[
          {
            label: "Clasificación del origen del peligro / Riesgo que generó el ausentismo",
            field: "clasification",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          }
        ],
        rows:[]
      },
      tableConfirm3: {
        columns:[
          {
            label: "Fecha de Inicio",
            field: "dateStart",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Fecha final",
            field: "dateEnds",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Días perdidos",
            field: "days",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Horas de ausencia",
            field: "hours",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
        ],
        rows:[]
      },
      tableConfirm4: {
        columns:[{
          label: "Descripción",
          field: "description",
          align: "center",
          headerClass: "theading",
          interpolate: true,
          sortable: false
        }],
        rows:[]
      },
      tableConfirm5: {
        columns:[
          {
            label: "Medico emisor",
            field: "medico",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "IPS emisor",
            field: "ips",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Origen incapacidad",
            field: "origen",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
        ],
        rows:[]
      },
      tableDescription: '',
      tabIndex:1,
      optionsIssuer:[{value:null,text:'Seleccione el emisor de la ausencia'}],
      optionsCertificate:[{value:null,text:'Estado del certificado de la Incapacidad'}],
      optionsOrigen:[{value:null,text:'Seleccione el origen de la Incapacidad'}],
      reportFrom: '',
      reportTo: '',
      dateAbs:'',
      daysAbs:'',
      hoursAbs:'',
      descriptionAbs:'',
      editAbsForm:false,
      showTitles:false,
      inabilityOrigin: '',
      medicalDisability: '',
      incapacityIps: '',
      riskDanger: null,  //classification_of_risk_or_danger
      diagnosticGroup: null, //diagnostic_group,
      emitterAbsence: null,  //emitter_of_absence
      dataErrors: [],
      showNextStep: true,
      file:'',
      processingSaveAbsenteeism: false
      ,errosSaveAbsenteeism: [],
      dataErrorsRegister: []
      ,stadisticsColors: [],
      // error: {
      //   flag: false,
      //   class: "", //is-valid
      //   message: "",
      // },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      }
      ,processing: false
    }
  },
  computed: {
    get_difference_register_absenteeism () {
      return (this.get_date_difference(this.reportFrom, this.reportTo) + 1)
    },
    get_difference_register_absenteeism_hours () {
      return (this.get_difference_register_absenteeism * 8)
    },
    ...mapState("modOhAnalyst", [
      "loading",
      "loading2",
      "error",
      "message",
      "employeeInfo",
      "typesAbsenteeism",
      "groupsDiagnostics",
      "diagnostics",
      "riskClassification",
      "listsAbsenteeism",
      "absenteeism",
      "historyAbs",
      "filters",
      "detailAbs",
    ]),
    ...mapGetters('modOhAnalyst'
        ,['getErrors','getMessage']
    ),
    validation() {
      const textRegex = /^[a-zA-Z\s]+$/;
      return textRegex.test(this.incapacityIps)
    },
  },
  beforeMount() {
    this.viewAbs(this.$route.params.eid);
    this.actGetTypesAbsenteeism();
  },
  watch: {
    reportTo() {
      if (this.reportFrom != null) {
        this.daysAbs = this.get_difference_register_absenteeism
        this.hoursAbs = this.get_difference_register_absenteeism_hours
      }
    }
  },
  methods: {
    ...mapActions("modOhAnalyst", [
      'actGetEmployeeInfo',
      'actGetTypesAbsenteeism',
      'actGetGroupsDiagnostics',
      'actGetDiagnostics',
      'actGetRiskClassification',
      'actGetListsAbsenteeism',
      'actSaveAbsenteeism',
      'actGetAbsenteeism',
      'actGetHistoryOfAbsenteeism',
      'getHistoryAbs',
      'actFilterEmployeeDetail',
      'actGetDetailAbsenteeism',
      'actActAbsenteeism',
    ]),
    validateText(text) {
    const regex = /^[A-Za-z\s]+$/; // Expresión regular para permitir solo texto

    return regex.test(text);
  },
    refreshData(){
      this.$emit('change:reload-data')
    },
    onFileChange(e){
      this.file = e.target.files[0];
    },
    getHours(){
      if (this.daysAbs < 1 || this.hoursAbs < 8) { return }
      this.hoursAbs = this.daysAbs * 8
    },
    filterTypesAbs(search,loading){
      loading(true)
      this.actGetTypesAbsenteeism(search).then(()=> loading(false))
      this.disableFirstStep();
    },
    filterGroupsDiagnostics(search,loading){
      loading(true)
      this.actGetGroupsDiagnostics(search).then(()=> loading(false))
      this.disableFirstStep();
    },
    filterRiskClassification(search,loading){
      loading(true)
      this.actGetRiskClassification(search).then(()=> loading(false))
      this.disableFirstStep();
    },
    filterDiagnosticsByGroup(){
      let search = {
        group:this.groupDiagnostic.id
      }
      this.actGetDiagnostics(search)
      this.disableFirstStep();
    },
    filterDiagnostics(name,loading){
      loading(true)
      let search = {
        search:name
      }
      this.actGetDiagnostics(search).then(() => { loading(false) })
      this.disableFirstStep();
    },
    checkTypeOfAbs(){
      console.log("funciona check")
      console.log(this.typeAbsence.options)
      if(!this.typeAbsence.options){
        this.diagnosticSelected = ''
        this.riskClassificationSelected = ''
      }
      this.showTitles = true
      this.riskDanger = this.typeAbsence.options.classification_of_risk_or_danger; // true or false
      console.log(this.riskDanger)
      this.diagnosticGroup = this.typeAbsence.options.diagnostic_group; // true or false
      this.emitterAbsence = this.typeAbsence.options.emitter_of_absence; // true or false
    },
    viewAbs(id){
      this.editAbsForm = false
      this.actGetAbsenteeism(id).then(() => {
        this.datatableEmployeeModal.columns = [
          {
            label: "Nombres y apellidos",
            field: "name",
            align: "center",
            headerClass: "theading",
            sortable: false
          },
          {
            label: "Área",
            field: "area",
            align: "center",
            headerClass: "theading",
            sortable: false
          },
          {
            label: "Cargo",
            field: "charge",
            align: "center",
            headerClass: "theading",
            sortable: false
          },
          {
            label: "Fecha de ingreso",
            field: "startDate",
            align: "center",
            headerClass: "theading",
            sortable: false
          },
        ]
        this.datatableEmployeeModal.rows=[]
        this.datatableEmployeeModal.rows.push({
          name:this.dataUser.employee,
          area:this.dataUser.area,
          charge:this.dataUser.charge,
          startDate:this.dataUser.created_at ?? 'Aún no tiene registro',
        })
        this.tableConfirm1.rows = []
        this.tableConfirm2.rows = []
        this.tableConfirm3.rows = []
        this.tableConfirm4.rows = []
        this.tableConfirm5.rows = []

        // const values = {
        //   null: this.no_apply,
        //   not_apply: this.no_apply
        // }
        this.tableConfirm1.rows.push({
          type:this.absenteeism.type_absenteeism_name,
          cie:(this.absenteeism.diagnostic_name == null? this.no_apply() :this.absenteeism.diagnostic_name),
          issuer: this.absenteeism.transmitter,
        })
        this.tableConfirm2.rows.push({
          clasification:(this.absenteeism.risk_classification_name == null? this.no_apply() :this.absenteeism.risk_classification_name)
        })

        this.tableDescription = this.absenteeism.description

        this.tableConfirm4.rows.push({
          description:this.absenteeism.description
        })

        this.tableConfirm5.rows.push({
          medico:this.absenteeism.doctor_name,
          ips:this.absenteeism.ips,
          origen:this.absenteeism.origin,
        })


        this.tableConfirm3.rows.push({
          dateStart:this.absenteeism.start_date,
          dateEnds:this.absenteeism.end_date,
          days:this.absenteeism.days,
          hours:this.absenteeism.hours
        })
        this.selectedCertificate = this.absenteeism.status
        this.typeAbsence = this.absenteeism.type_absence;
        this.riskClassificationSelected = this.absenteeism.risk_classification_name;
        this.groupDiagnostic = this.absenteeism.group_diagnostic_name;
        this.diagnosticSelected = this.absenteeism.diagnostic_name;
        this.selectedIssuer = this.absenteeism.transmitter;
        this.actGetListsAbsenteeism().then(() => {
          this.optionsIssuer = []
          this.listsAbsenteeism.transmitter.forEach(x => {
            this.optionsIssuer.push({
              value: x,
              text: x.name
            })
          });
          // this.selectedIssuer = this.absenteeism.transmitter;
          for (let index = 0; index < this.optionsIssuer.length; index++) {
            if (this.optionsIssuer[index].value.id === this.absenteeism.transmitter_id) {
              this.selectedIssuer = this.optionsIssuer[index].value
            }
          }
          this.optionsCertificate = []
          this.listsAbsenteeism.status_certificate.forEach(x => {
            this.optionsCertificate.push({
              value: x,
              text: x.name
            })
          })
          this.optionsCertificate.forEach(x => {
            if (x.value.id == this.absenteeism.state_id) {
              this.selectedCertificate = x.value
            }
          })
          this.listsAbsenteeism.origin.forEach(x => {
            this.optionsOrigen.push({
              value: x,
              text: x.name
            })
          })
          this.optionsOrigen.forEach(x => {
            if (x.value != null && x.value.id == this.absenteeism.origin_id) {
              this.inabilityOrigin = x.value
            }
          });
        })
        this.reportFrom = this.absenteeism.start_date
        this.reportTo = this.absenteeism.end_date
        this.daysAbs = this.absenteeism.days
        this.hoursAbs = this.absenteeism.hours
        this.descriptionAbs = this.absenteeism.description
        this.medicalDisability = this.absenteeism.doctor_name
        this.incapacityIps = this.absenteeism.ips
      })
    },
    no_apply () {
      return 'No Aplica'
    },
    async SaveEditAbs() {
      let data = {
        "start_date": this.reportFrom,
        "end_date": this.reportTo,
        "days": this.daysAbs,
        "hours": this.hoursAbs,
        "core_employee_id": this.dataUser.id,
        "type_absence_id": this.typeAbsence.id ? this.typeAbsence.id : this.absenteeism.type_absence_id,
        "diagnosis_cie_id": this.diagnosticSelected.id ? this.diagnosticSelected.id : this.absenteeism.diagnostic_id,
        "risk_classification_id": this.riskClassificationSelected.id  ? this.riskClassificationSelected.id  : this.absenteeism.risk_classification_id,
        "transmitter": this.selectedIssuer.id,
        "description": this.descriptionAbs,
        "status": this.selectedCertificate.id,
        "id": this.absenteeism.id,
        "origin_of_disability" : this.inabilityOrigin.id ? this.inabilityOrigin.id :  this.absenteeism.transmitter_id,
        "physician_who_issues_disability":  this.medicalDisability,
        "ips_issuing_disability": this.incapacityIps,
        
      }
      if (
          this.file !== ''
      )
      {
        data.push('file', this.file )
      }
      this.processing = true
      await this.actActAbsenteeism(data)
        .then(() => {
          if(this.error.message){
          this.$root.$emit('bv::hide::modal','modal-confirm')
          this.$root.$emit('bv::show::modal','modal-fail')
          }else{
            this.$root.$emit('bv::hide::modal','modal-confirm')
            this.$root.$emit('bv::show::modal','modal-success')
          }
        })
        .catch(({ response }) => {
          console.log(response)
          this.errosSaveAbsenteeism = response
          this.$root.$emit('bv::show::modal','modal-fail')
          this.$bvModal.show('modal-fail')
        }).finally(() => {
          this.processing = false
          console.log("funciona arriba")
        })
    },
    disableFirstStep() {
       this.dataErrors = [];
      if (this.typeAbsence != null && this.typeAbsence.options) {
        if (this.riskDanger && this.riskClassificationSelected == '') {
          this.dataErrors.push("Debe seleccionar un riesgo")
        }
        if (this.diagnosticGroup && this.groupDiagnostic == '') {
          this.dataErrors.push("Debe seleccionar un grupo diagnostico")
        } else if (this.diagnosticSelected && this.diagnosticSelected == '') {
          this.dataErrors.push("Debe seleccionar un Diagnóstico")
        }
        if (this.emitterAbsence && this.selectedIssuer == '' || this.selectedIssuer == null) {
          this.dataErrors.push("Debe seleccionar un Emisor")
        }
        if (!this.dataErrors.length) {
          this.showNextStep = false;
        }else{
          this.showNextStep = true;
        }
      }else{
        this.showNextStep = true;
      }
      return true;
    },
  }
}
</script>

<style lang="scss">

#popover {
  font-family: 'Ubuntu';
  font-style: normal;
  font-size: 16px;
  border: 0;
  height: auto;
  word-wrap: break-word;
  p {
    font-size: 12px;
  }
}
.b-popover {
  border-radius: 10px;
  border: 0;
  font-family: 'Ubuntu';
  font-style: normal;
  font-size: 16px;

  p.separate{
    color: #0075FF;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0em;
  }
  .popover-header{
    border-radius: 10px;
  }
  .popover-body{
    max-width: 400px;
    .b-form-datepicker{
      padding: 3px;
      border: #d8d8d8 1px solid !important;
    }
    select, input{
      padding: 5px;
      height: 40px;
      border-radius: 8px;
    }
  }
}

.btn .b-icon.bi, .nav-link .b-icon.bi, .dropdown-toggle .b-icon.bi, .dropdown-item .b-icon.bi, .input-group-text .b-icon.bi {
  color: var(--main-primary-color);
  font-size: 130%;
}

.popover-body {
  width: 348px;
  height: auto;
  word-wrap: break-word;

  /* Neutral / White */
  background: #FFFFFF;

  /* Neutral / Gray blue light */
  border: 1px solid #F5F5F5;

  /* Mid */
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.multiselect__option--highlight {
  background: var(--main-primary-color);
}

.multiselect__option--highlight::after {
  background: var(--main-primary-color);
}

.multiselect__tag {
  background: var(--main-primary-color);
}

.multiselect__tag-icon::after {
  background: var(--main-primary-color);
}

.multiselect__tag-icon:hover {
  background: var(--main-primary-color);
}



#absenteeism{
  .error {
    font-size: 11px;
    margin-top: 2px;
    opacity: 0;
    display: flex;
    transition: all 0.4s ease;
  }
  .error-active {
    .error {
      opacity: 1;

    }
    .custom-select,
    .vs__dropdown-toggle,
    input {
      border: 1px solid red;
    }
  }
  input {
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: 10px;
    transition: all 0.4s ease;
  }
  .vs__selected-options input {
    border: none; 
  }
  textarea {
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: 10px;
    margin-top: 1.5rem !important;
    margin-bottom: 1rem !important;
    padding: 10px;
  }
  .b-form-btn-label-control {
    height: 50px;
    align-items: center;
    border-radius: 10px;
  }
  .btn-success {
    margin-top: 60px;
    padding: 14px;
    border-radius: 10px;
    font-size: 12px;
  }

  .cardEstadistics {
    border: 1.0263px solid #F5F5F5;
    border-radius: 25px;
    p{
      font-size: 12px;
    }
  }
  .custom-select{
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }
  .btn-create{
    padding: 12px;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    transition: 0.5s;
    span {
      font-size: 30px;
      line-height: 0;
      margin: 0 5px;
      font-weight: 500;
    }
  }
  .btn-create:hover{
    background-color: #7A7CFF;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
  }
  /*.status{
      padding: 5px 15px;
      border-radius: 20px;
  }*/
  .buttonColapse{
    padding: 6px 12px;
    gap: 4px;
    border: 2px solid #7A7CFF;
    color:#7A7CFF;
    font-size: 14px;
    border-radius: 100px;
  }
  .buttonColapse2{
    padding: 6px 12px;
    gap: 4px;
    color:#FFFFFF;
    font-size: 16px;
    background: #7A7CFF;
    border-radius: 4px;
  }
  .btn-outline-success:hover, .btn-success{
    color: white;
    background-color: #7A7CFF;
    border-color: #7A7CFF;
  }
  .btn-success:hover{
    background-color: #7A7CFF;
  }
  .regular{
    background-color: #FFFFFF;
    padding: 6px 12px;
    gap: 4px;
    border: none;
    color: #7A7CFF;
    border: 1px solid #5D5FEF;
    border-radius: 4px;

  }
}
.history-absenteeism {
  label {
    color: #78909C;
  }
  .title-form-history {
    font: normal normal 700 16px/1 "Ubuntu";
    color: #004BD1;
  }
  .btn-save {
    width: max-content;
    display: block;
    padding: 12px;
    text-transform: uppercase;
  }
  .box-btn {
    margin-top: 50px;
  }
  .vs__selected-options {
    padding: 8px;
    font-size: 16px;
    min-height: 50px;
    border-radius: 8px;
    margin: 0;
    input  {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      margin: 0;
    }
  }
  .form-group {
    position: relative;
  }
  label:not(.form-control){
    /* label */
    position:absolute;
    z-index: 9;
    left: 4px;
    top: 8px;
    font: normal normal 300 12px/1 "Ubuntu";
    /* identical to box height, or 133% */
    display: flex;
    align-items: center;
    /* content/02 */
    color: #B0BEC5;
    background: #ffffff;
    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 4px;
    padding: 0px 4px;
  }
  .vs__selected {
    word-break: break-word;
    margin: 0 !important;
    height: 100%;
    top: 0;
  }
  .vs__dropdown-toggle {
    border: 1px solid #B0BEC5;
    border-radius: 8px;
    padding: 0;
  }
  .vs__dropdown-toggle input {
    color: #78909C;
    font: normal normal 300 16px/1 "Ubuntu";
    &::placeholder {
      color: #78909C;
    }
  }
  .box-input {
    position: relative;
    label:not(.form-control) {
      top: -6px;
    }
  }
  .custom-select {
    background: #fff url("../../assets/images/icons/arrow-select.svg") right 0.75rem center/30px 30px no-repeat;
  }
}

</style>

